import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import TablaCamionesConRemitoView from '../components/TablaCamionesConRemitoView'
import { actualizarDatosParaMuiTable } from '../actions/TablaCamionesConRemitoActions'
import { getActRemitosTotal } from '../../../actions'

function CamionesConRemito (props) {
  const { actualizarDatosParaMuiTable, show, getActRemitosTotal } = props

  useEffect(() => {
    actualizarDatosParaMuiTable()
    getActRemitosTotal()
  }, [actualizarDatosParaMuiTable, getActRemitosTotal])

  return (
    <>
      {show && <TablaCamionesConRemitoView /> }
    </>
  )
}

const mapStateToProps = (state) => ({
  ultimaActualizacion: state.dashboard.uaCamionesRemitosTotal,
  show: state.dashboard.showTablaRemitos
})

const mapActionsToProps = {
  actualizarDatosParaMuiTable,
  getActRemitosTotal
}

const withRedux = connect(mapStateToProps, mapActionsToProps)
export default withRedux(CamionesConRemito)
